import type { ReactElement } from 'react'

import CategoryForm from './CategoryForm'
import DateForm from './DateForm'

import Modal from '~/components/Modal'

export const MODAL_ID = 'catalog-modal'

interface Props {
  isOpen: boolean
  onClose: VoidFunction
  selectedTemplate: string
  type: 'daily' | 'category'
}

const AddToModal = ({ isOpen, onClose, selectedTemplate, type }: Props): ReactElement => {
  return (
    <Modal id={MODAL_ID} isOpen={isOpen} onCloseModal={onClose}>
      {type === 'daily' ? <DateForm onClose={onClose} selectedTemplate={selectedTemplate} /> : null}
      {type === 'category' ? <CategoryForm onClose={onClose} selectedTemplate={selectedTemplate} /> : null}
    </Modal>
  )
}

export default AddToModal
